import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import TwoFa from "../../elements/twoFa/TwoFa";
import DialogModal from "../../elements/dialogModal/DialogModal";
import { TextField } from "@material-ui/core";
import DefaultButton from "../../styles/materialButtonStyle";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import { StyledBlockAction, StyledInputBlock } from "../../styles/styledTabsForm";

const DefaultFeeEditForm = ({ fee, notification, setNotification, url }) => {
  const { t } = useTranslation("defaultFeePage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    percent: null,
    constant: null,
    min: null,
    max: null
  });

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put(url + fee.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("details.changeForm.success") });
      }
    }).catch(error => {
      setOpen(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.changeForm.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        className="fee-edit"
        onSubmit={event => {
          event.preventDefault();

          setSubmitData({
            ...setSubmitData,
            percent: event.target.percent.value,
            constant: event.target.constant.value,
            min: event.target.min.value,
            max: event.target.max.value
          });
          setOpen(true);
        }}
      >
        <div className="fee-edit__items">
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.percent")}
            type="text"
            value={fee.baseFee.percent * 100}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.constant")}
            type="text"
            value={fee.baseFee.constant}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.min")}
            type="text"
            value={fee.baseFee.min}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.max")}
            type="text"
            value={fee.baseFee.max}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
        </div>
        <div className="fee-edit__items">
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.changeForm.percent")}
            id="percent"
            type="text"
            name="percent"
            defaultValue={fee.percent * 100}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.changeForm.constant")}
            id="constant"
            type="text"
            name="constant"
            defaultValue={fee.constant}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.changeForm.min")}
            id="min"
            type="text"
            name="min"
            defaultValue={fee.min}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.changeForm.max")}
            id="max"
            type="text"
            name="max"
            defaultValue={fee.max}
          />
        </div>
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("details.changeForm.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default DefaultFeeEditForm;